import React, { useContext } from 'react';
import Slider from 'react-slick';
import { Button, Rating } from '@mui/material';
import './customers.css';
import { GetAllReviewsInfo } from '../../Api/PortalApis';
import { useState, useEffect } from 'react';
import googleIcon from '../../assets/images/customer/googleLogo.png';
import ratingIcon from '../../assets/images/customer/rating.png';
import gIcon from '../../assets/images/customer/GIcon.png';
import StarIcon from '@mui/icons-material/Star';
import CallMadeIcon from '@mui/icons-material/CallMade';
import { MyContext } from '../../context';

function getRandomObjectsFromArray(array, count) {
  if (array.length > count) {
    const shuffled = array.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  } else {
    return array;
  }
}

function formatDate(dateString) {
  const date = new Date(dateString);
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return date.toLocaleDateString('en-IN', options);
}

function Customers() {
  const { pageData, country } = useContext(MyContext);

  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [activate, setActivate] = useState(0);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 0,
    variableWidth: true,
    cssEase: 'linear',
    afterChange: (index) => setActiveSlideIndex(index),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          sliderToShow: 0.8,
          variableWidth: false,
        },
      },
      {
        breakpoint: 550,
        settings: {
          sliderToShow: 1.3,
        },
      },
    ],
  };
  // let settings = {
  //   arrows: false,
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         sliderToShow: 0.8,
  //         variableWidth: false,
  //       },
  //     },
  //     {
  //       breakpoint: 550,
  //       settings: {
  //         sliderToShow: 1.3,
  //       },
  //     },
  //   ],
  // };

  const [userReviews, setUserReviews] = useState([]);
  useEffect(() => {
    // Use static review data here
    const reviews = getRandomObjectsFromArray(
      pageData?.reviewPage?.reviewsData,
      5
    );
    setUserReviews(reviews);
  }, [country]);

  useEffect(() => {
    if (activeSlideIndex === userReviews?.length - 1) setActivate(0);
    else setActivate(activeSlideIndex + 1);
  }, [activeSlideIndex]);
  return (
    <section className="customers">
      <div className="container" width="70% !important">
        <div className="customer-review-header">
          <div>
            <h2>{pageData?.reviewPage?.header}</h2>
            <p style={{ paddingTop: '0px', marginBottom: '15px' }}>
              {pageData?.reviewPage?.subTitle}
            </p>
          </div>
          <div className="customer-review-header-right">
            <img
              loading="lazy"
              src={googleIcon}
              width="100px"
              alt="google-icon"
            />
            <img
              loading="lazy"
              src={ratingIcon}
              className="img-rating"
              alt="rating-icon"
            />
          </div>
        </div>
        <Slider {...settings}>
          {userReviews.map((review, index) => (
            <div className="customer-card-wraper" key={index}>
              <div
                className={
                  index === activate
                    ? 'customer-card customer-card-active'
                    : 'customer-card'
                }
              >
                <div className="customer-card-profile">
                  <p>{review?.description}</p>
                  <span
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginTop: '2rem',
                    }}
                  >
                    <div>
                      <h5>{review?.reviewer_name}</h5>
                      {/* <label>Maruti swift</label> */}
                      {/* <label>{formatDate(review.date_of_review)}</label> */}
                    </div>
                    <Rating
                      name="half-rating-read"
                      defaultValue={5}
                      precision={0.5}
                      style={{ color: '#0c286a' }}
                      readOnly
                    />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </Slider>
        <div className="customer-review-footer">
          <div>
            <Button
              variant="contained"
              endIcon={
                <img loading="lazy" src={gIcon} alt="" width="30px"></img>
              }
              sx={{
                width: '100%',
                height: '60px',
                fontSize: '24px',
                backgroundColor: '#eff2ff',
                textTransform: 'none',
                fontFamily: 'matterThin !important',
                color: '#0c286a',
                boxShadow: 'none',
              }}
              className="reviews-on-Google"
            >
              {pageData?.reviewPage?.buttonText}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Customers;
